$(document).ready(function () {

    //Deals and Rewards Script

    //Apply class to deals component if user not logged in and there is no rewards component present
    var numComponents = $('.checkout-toggle').length;
    if (numComponents === 1) {
        $('.deals-component').addClass('no-rewards');
        $('.deals-toggle').addClass('no-rewards-mobile');
    }

    //Function to expand component
    function expandComponent(selector) {
        $(selector).addClass('expanded');
        $(selector).next('.pullup-body').addClass('expanded');
        $(selector).removeClass('collapsed');
        $(selector).next('.pullup-body').removeClass('collapsed');
    }

    //Function to collapse component
    function collapseComponent(selector) {
        $(selector).removeClass('expanded');
        $(selector).next('.pullup-body').removeClass('expanded');
        $(selector).addClass('collapsed');
        $(selector).next('.pullup-body').addClass('collapsed');
    }

    var desktopToggleComponents = function () {
        if (!($(this).hasClass('expanded'))) {
            expandComponent(this);
        } else {
            collapseComponent(this);
        }
    };

    var mobileToggleDeals = function () {
        if (!($(this).hasClass('expanded'))) {
            expandComponent(this);
            collapseComponent('.rewards-toggle');
            $(this).find('.toggle-underline').removeClass('deselected');
            $('.rewards-toggle .toggle-underline').addClass('deselected');
        } else {
            collapseComponent(this);
            $('.rewards-toggle .toggle-underline').removeClass('deselected');
        }
    };

    var mobileToggleRewards = function () {
        if (!($(this).hasClass('expanded'))) {
            expandComponent(this);
            collapseComponent('.deals-toggle');
            $(this).find('.toggle-underline').removeClass('deselected');
            $('.deals-toggle .toggle-underline').addClass('deselected');
        } else {
            collapseComponent(this);
            $('.deals-toggle .toggle-underline').removeClass('deselected');
        }
    };

    //functionality for deals/rewards component in desktop
    if ($(window).width() > 1023) {
        $('.deals-toggle, .rewards-toggle').on('click', desktopToggleComponents);
    }
        //functionality for deals/rewards component in mobile
    else {
        $('.deals-toggle').on('click', mobileToggleDeals);
        $('.rewards-toggle').on('click', mobileToggleRewards);
    }

    //Moves the rewards from the applied section to the available section and vice versa
    $('.move-reward').on('click', function () {
        if ($(this).closest('.rewards-item').hasClass('rewards-applied')) {
            $(this).closest('.rewards-item').removeClass('rewards-applied').addClass('rewards-available').appendTo('.rewards-available-list');
            $('.rewards-available .move-reward').html('Add');
        }
        else {
            $(this).closest('.rewards-item').removeClass('rewards-available').addClass('rewards-applied').appendTo('.rewards-applied-list');
            $('.rewards-applied .move-reward').html('Remove');
        }
    });


    //Deletes deals from the deals component
    $('.delete-deal').on('click', function () {
        $(this).closest('.deals-item').addClass('hide-remove');
    });


    //Load more button loads
    var size_li = $(".rewards-applied-list li").length;
    var x = 5;
    var loadedRewards = 5;
    if (loadedRewards >= size_li) {
        $('.load-more-button').addClass('hide-remove');
    }
    $('.rewards-applied-list li:lt(' + x + ')').show();
    $('.load-more-button').click(function () {
        x = (x + 5 <= size_li) ? x + 5 : size_li;
        loadedRewards += 5;
        if (loadedRewards >= size_li) {
            $('.load-more-button').addClass('hide-remove');
        }
        $('.rewards-applied-list li:lt(' + x + ')').show();

    });
    

    //Clicking on update button will close the rewards component
    $('.update-rewards').on('click', function () {
        collapseComponent('.rewards-toggle');
    });

});

